import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FormattedMessage, injectIntl } from 'react-intl';
import m from './messages';
import AlertConfirmDelete from './alert-confirm-delete';
import mockTableLists from './mock-table-lists';
import url from '../../url-service';



function TableFavorites({ type, data, countItems, listByType }) {
  const [ itemForDelete, setItemForDelete ] = useState(null);
  const [ tableList, setTableList ] = useState(mockTableLists[type])

  useEffect(
    () => {
      setTableList(mockTableLists[type])
    }, [type]
  )


  if (!tableList) return null;

  const renderTitleCell = (title, index) => {
    if (index === 0 && listByType) return 'Name';
    if (index !== 0) return title;

    const minCountItems = 5;
    return (
      <>
        { title } 
        { (!listByType && countItems > minCountItems) && 
          (<>
            {' '}
            <FormattedMessage 
                {...m.itemsCount} 
                values={{ number: <Link to={`/favorites/${type}`}>{countItems}</Link> }} 
            />
          </>
          )
        }
      </>
    )
  }

  const renderDeleteButton = (type, item) => {
    return <button className='icon iconTrash link' onClick={() => setItemForDelete({type, item})}/>
  }

  const getHeaderRow = () => (
    <div className='table__row table__row--header'>
      { tableList.titles.map(
        (title, index) => (<div key={title} className='table__col'>{renderTitleCell(title, index)}</div>)
      )}
    </div>
  )
  
  if (!data.length) return null;
  return (
    <div className={`table table--favorites-${type}`}>
      { getHeaderRow() }
      { data.map((item, index) => (
          <div key={index} className='table__row'>
            {tableList.getCellItems(item)}
            <div className='table__col'>
              { renderDeleteButton(type, item) }
            </div>
          </div>
        )
      )}
      { itemForDelete && <AlertConfirmDelete itemForDelete={itemForDelete} setItemForDelete={setItemForDelete} listByType={listByType} /> }
    </div>
  )
}

TableFavorites.defaultProps = {
  data: []
}

TableFavorites.propsTypes = {
  type: PropTypes.string,
  countItems: PropTypes.number,
  data: PropTypes.arrayOf(PropTypes.object),
  listByType: PropTypes.bool
}

export default injectIntl(TableFavorites);